import { render, staticRenderFns } from "./NavCategoriesLink.vue?vue&type=template&id=3258aecc&scoped=true&"
import script from "./NavCategoriesLink.vue?vue&type=script&lang=js&"
export * from "./NavCategoriesLink.vue?vue&type=script&lang=js&"
import style0 from "./NavCategoriesLink.vue?vue&type=style&index=0&id=3258aecc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258aecc",
  null
  
)

export default component.exports